import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Paper,
  Typography,
  TextField,
  Alert,
  CircularProgress,
  MenuItem,
  FormControl,
  InputLabel,
  Select
} from '@mui/material';
import { firewallService } from '../services/api';

function AddFirewall() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    device_name: '',
    ip_address: '',
    username: '',
    password: '',
    type: '',
    protocol: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const payload = { ...formData };
      if (payload.type !== 'cisco_ftd' && payload.type !== 'juniper_srx' && payload.type !== 'paloalto_panos') payload.protocol = 'SSH';
      await firewallService.createFirewall(payload);
      navigate('/firewalls');
    } catch (error) {
      setError(error.response?.data?.detail || 'Error adding firewall');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Add New Device
      </Typography>

      <Paper sx={{ p: 3 }}>
        <form onSubmit={handleSubmit}>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <FormControl fullWidth margin="normal" required>
            <InputLabel>Device Type</InputLabel>
            <Select
              name="type"
              value={formData.type}
              onChange={handleChange}
              label="Device Type"
            >
              <MenuItem value="juniper_srx">Juniper SRX</MenuItem>
              <MenuItem value="huawei_usg">Huawei USG</MenuItem>
              <MenuItem value="fortinet_fortigate">Fortinet FortiGate</MenuItem>
              <MenuItem value="cisco_ftd">Cisco FTD</MenuItem>
              <MenuItem value="paloalto_panos">PaloAlto PAN-OS</MenuItem>
              <MenuItem value="checkpoint_security_gateway">Checkpoint Security Gateway</MenuItem>
            </Select>
          </FormControl>

          {(formData.type === 'cisco_ftd' || formData.type === 'juniper_srx' || formData.type === 'paloalto_panos') && (
            <FormControl fullWidth margin="normal" required>
              <InputLabel>Protocol</InputLabel>
              <Select
                name="protocol"
                value={formData.protocol}
                onChange={handleChange}
                label="Protocol"
              >
                <MenuItem value="SSH">SSH</MenuItem>
                <MenuItem value="API">API</MenuItem>
              </Select>
            </FormControl>
          )}

          <TextField
            fullWidth
            label="Device Name"
            name="device_name"
            value={formData.device_name}
            onChange={handleChange}
            required
            margin="normal"
            helperText="Enter a unique name for this device"
          />

          <TextField
            fullWidth
            label="IP Address"
            name="ip_address"
            value={formData.ip_address}
            onChange={handleChange}
            required
            margin="normal"
            placeholder="e.g. 192.168.1.1 or ftd.securemango.com"
            helperText="Enter the IP address or domain name of the device"
          />

          <TextField
            fullWidth
            label="Username"
            name="username"
            value={formData.username}
            onChange={handleChange}
            required
            margin="normal"
            helperText="Enter the admin username"
          />

          <TextField
            fullWidth
            label="Password"
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            required
            margin="normal"
            helperText="Enter the admin password"
          />

          <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={loading}
              startIcon={loading ? <CircularProgress size={20} /> : null}
            >
              {loading ? 'Adding...' : 'Add Device'}
            </Button>
            <Button
              variant="outlined"
              onClick={() => navigate('/firewalls')}
              disabled={loading}
            >
              Cancel
            </Button>
          </Box>
        </form>
      </Paper>
    </Box>
  );
}

export default AddFirewall; 